import { Form, Select } from 'antd'
import {EnterOutlined} from "@ant-design/icons";
import React, {useMemo} from "react";

const actions = [
  {
    label: 'Transferir p/ Assistente',
    value: 'InVerbeux',
  },
  {
    label: 'Aguardando Atendimento',
    value: 'Waiting',
  },
  {
    label: 'Atendimento em progresso',
    value: 'InProgress',
  },
]

const modes = [
  {
    label: "Tags AI",
    value: "AI"
  },
  {
    label: "Tags Fixas",
    value: "Fixed"
  }
]

export default function ChangeStatus({ fieldName, form, parameters }) {
  const mode = Form.useWatch(['actions', fieldName, 'action', 'data', 'mode'], form)

  const availableArrayString = useMemo(() => {
    const props = parameters?.properties
    if (!props) return []
    const arr = Array.isArray(props)
      ? props
      : Object.entries(props).map(([name, schema]) => ({ name, ...schema }))
    return arr
      .filter(({ type, items }) => type === 'array' && items?.type === 'string')
      .map(({ name }) => ({ label: name, value: name }))
  }, [parameters])

  console.log({availableArrayString, parameters})

  return (
    <>
      <Form.Item
        label={'Estado'}
        name={[fieldName, 'action', 'data', 'status']}
      >
        <Select options={actions} placeholder={'Selecione o estado'} />
      </Form.Item>
      <Form.Item name={[fieldName, 'action', 'data', 'mode']}
                 initialValue={'Fixed'}
                 label={'Modo de etiquetas'}>
        <Select options={modes} placement={"Selecione o modo de etiquetas"}/>
      </Form.Item>
      {mode === 'Fixed' && <Form.Item
        label={'Etiquetas'}
        name={[fieldName, 'action', 'data', 'labels']}
      >
        <Select
          mode="tags"
          open={false}
          maxCount={20}
          suffixIcon={<EnterOutlined/>}
          placeholder="Digite o etiqueta e dê enter em seguida"
        />
      </Form.Item>}
      {mode === 'AI'  && <Form.Item
        label={'Etiquetas geradas por ai'}
        name={[fieldName, 'action', 'data', 'labelAI']}
        help={'Selecione um parametro do gatilho que seja uma lista de textos'}
      >
        <Select placeholder={'Selecione um parametro do gatilho'} options={availableArrayString}/>
      </Form.Item>}
    </>
  )
}
